<template>
  <div class="index-container">
    <div class="page-title">出货单管理</div>
    <div class="condition-box">
      <div class="info-value-box">
        <div class="info-title">时间：</div>
        <el-date-picker
          value-format="yyyy-MM-dd"
          @change="select_dateChange"
          v-model="select_date"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </div>
      <div class="info-value-box">
        <div class="info-title">客户({{clientNum}})：</div>
        <el-select @change="clientChange" v-model="client" placeholder="请选择">
          <el-option v-for="(item,key) in clientList" :key="key" :label="key" :value="item"></el-option>
        </el-select>
      </div>
      <div class="info-value-box">
        <div class="info-title">出货单({{billList.length}})：</div>
        <el-select @change="billChange" v-model="bill" placeholder="请选择">
          <el-option v-for="item in billList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>
    </div>
    <div class="button-box">
      <el-button type="primary" class="new-add-button" @click="exportExcel">导出EXCEL</el-button>
    </div>
    <div class="content-box">
      <div class="title">销售清单</div>
      <div class="info-value-box">
        <div class="info-title">PO：</div>
        {{order_num}}
      </div>
      <div class="detail-box">
        <div class="info-value-box">
          <div class="info-title">客户名称：</div>
          {{detail.name}}
        </div>
        <div class="info-value-box">
          <div class="info-title">收款方式：</div>
          {{detail.collection}}
        </div>
        <div class="info-value-box">
          <div class="info-title">含税：</div>
          {{detail.tax}}
        </div>
        <div class="info-value-box">
          <div class="info-title">日期：</div>
          {{delivery_date}}
        </div>
        <div class="info-value-box">
          <div class="info-title">送货地址：</div>
          {{detail.receipt_addr}}
        </div>
        <div class="info-value-box">
          <div class="info-title">仓库：</div>
          {{store}}
        </div>
        <div class="info-value-box">
          <div class="info-title">币种：</div>
          {{detail.currency}}
        </div>
        <div class="info-value-box">
          <div class="info-title">NO：</div>
          {{bill}}
        </div>
      </div>
      <el-table border :data="tableData" style="width:100%;overflow:auto;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="materials" label="物料编号"></el-table-column>
        <el-table-column prop="model" label="产品型号"></el-table-column>
        <el-table-column prop="package" label="封装"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="quantity" label="数量"></el-table-column>
        <el-table-column prop="price_sum" label="单价"></el-table-column>
        <el-table-column prop="price" label="金额"></el-table-column>
        <el-table-column prop="delivery_lot" label="发货批号"></el-table-column>
        <el-table-column prop="order_num" label="订单号"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from '../api/api';

export default {
  data() {
    return {
      select_date: '',
      clientList: [],
      client: '',
      billList: [],
      bill: '',
      detail: {
        order_num: ''
      },
      tableData: [],
      delivery_date: '',
      order_num: '',
      store: '',
      clientNum: 0
    };
  },
  mounted() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let date = new Date().getDate();
    if (date < 10) {
      date = '0' + date;
    }
    this.select_date = year + '-' + month + '-' + date;
    this.getClientList();
  },
  methods: {
    exportExcel() {
    console.log(this.bill)
      api.exportExcel(this.bill).then(res => {
        const result = res.data;
        if (result.code == 200) {
          window.location.href = result.data;
        }
      });
    },
    select_dateChange(val) {
      this.clientList = [];
      this.client = '';
      this.bill = '';
      this.billList = '';
      this.order_num = '';
      this.detail = {};
      this.delivery_date = '';
      this.store = '';
      this.bill = '';
      this.tableData = [];
      if (val) {
        this.getClientList();
      }
    },
    getClientList() {
      const params = {
        select_date: this.select_date
      };
      api.getClientList(params).then(res => {
        const result = res.data;
        if (result.code == 200) {
          this.clientList = result.data;
          let arr = Object.keys(this.clientList);
          this.clientNum = arr.length;
        }
      });
    },
    clientChange(val) {
      this.bill = '';
      this.billList = val;
      this.order_num = '';
      this.detail = {};
      this.delivery_date = '';
      this.store = '';
      this.bill = '';
      this.tableData = [];
    },
    billChange(val) {
      api.getBillInfo({ delivery_num: this.bill }).then(res => {
        const result = res.data;
        if (result.code == 200 && result.data) {
          this.tableData = result.data;
          this.detail = result.data[0].client;
          this.order_num = result.data[0].order_num;
          this.delivery_date = result.data[0].delivery_date;
          this.store = result.data[0].store;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.condition-box {
  display: flex;
  justify-content: space-around;

  .info-value-box {
    display: flex;
    align-items: center;
  }
  .info-title {
    flex-shrink: 0;
    width: 100px;
    text-align: right;
  }
}
.button-box {
  text-align: right;
}
.index-container {
  position: relative;
  flex: 1;
  padding: 32px;
  overflow: auto;
  .page-title {
    padding-bottom: 20px;
    font-size: 24px;
  }
}
.info-value-box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.info-title {
  flex-shrink: 0;
  width: 100px;
  text-align: right;
}
.content-box {
  padding: 40px 0;
  .title {
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
}
.detail-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
  .info-value-box {
    display: flex;
    align-items: center;
    width: 24%;
    margin-bottom: 30px;
  }
  .info-title {
    flex-shrink: 0;
    width: 100px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/billList.vue